import moment from 'moment'

export const userUntilFurtherNoticeDate = '9999-12-31'

export class UserDetailsModel {
  constructor() {
    this.id = null
    this.firstName = ''
    this.lastName = ''
    this.email = ''
    this.phoneNumber = ''
    this.languageCode = 'sv'
    this.username = ''
    this.startDate = moment().format('YYYY-MM-DD')
    this.endDate = moment(userUntilFurtherNoticeDate).format('YYYY-MM-DD')
    this.stores = []
    this.additionalAuthorities = []
    this.representative = null
  }
}
